import './style';
import 'bootstrap/dist/js/bootstrap.bundle';
import {CopyFields} from './copy/copy-fields';
import {Sidebar} from './sidebar/sidebar';
import Choices from 'choices.js';
import './utils/modal';

new CopyFields();
new Sidebar();

const elementsChoice = document.querySelectorAll('.js-choice');
for (const element of elementsChoice) {
  if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) {
    continue;
  }

  const choiceElement = new Choices(element, {
    removeItemButton: true,
    allowHTML: false,
    placeholder: false,
    addItemText: (value) => {
      return `Eingabetaste drücken, um "${value}" hinzuzufügen`;
    },
    itemSelectText: 'Zum Auswählen klicken',
  });

  if (element instanceof HTMLInputElement) {
    const listElement = choiceElement.containerInner.element.querySelector('.choices__list--multiple');

    if (listElement && listElement.children.length === 0) {
      const rawValue = element.getAttribute('placeholder');
      if (rawValue) {
        const itemsArray = rawValue.split(',').map(item => item.trim()).filter(Boolean);

        if (itemsArray.length > 0) {
          choiceElement.setValue(itemsArray);
        }
      }
    }
  }

  if (element instanceof HTMLSelectElement) {
    const passedElement = choiceElement.passedElement.element;
    passedElement.addEventListener('change', function() {
      const placeholder = choiceElement.containerInner.element.querySelector('input[type=search]');

      if (placeholder instanceof HTMLInputElement) {
        if ('selectedOptions' in passedElement && passedElement.selectedOptions.length > 0) {
          placeholder.style.display = 'none';
        } else {
          placeholder.style.display = 'inline-block';
        }
      }
    });
  }
}
